module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_7042.d02f4384.png";